import React from 'react';


type Props = {
    item       : any,
    isSelected?: boolean,
    onClick    : callback,
    className? : string
}

export default function ItemViewLeftMenuItem(props:Props) {

    const onClick = () => {props.onClick(props.item.id)}

    return (
        <div className={Classes("item", props.className, {selected: props.isSelected})} onClick={onClick}>
            <div className="row">
                <div className={Classes("icon", props.item.icon)}/>
                <div className="name">{props.item.label}</div>
                {!_.isNil(props.item.counter) && <div className="counter">{props.item.counter}</div>}
            </div>
        </div>
    )
}
